import DTConfirmation from '../DTConfirmationView/DTConfirmation';

const SendMacroAndConfirmAddressChange = () => {
  return <DTConfirmation message={"The customer's address has been updated."} />;
};

export default SendMacroAndConfirmAddressChange;
